module.exports = __webpack_public_path__ + "img/newCard.2421843e.png";